import { useTranslation } from 'react-i18next';

export default function FooterSection() {
  const { t } = useTranslation('common');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-bridge-line text-3xl text-cyan-400"></i>
              </div>
              <div>
                <div className="text-xl font-bold">BridgeOn Solutions</div>
                <div className="text-xs text-cyan-300">Digital Creative</div>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                >
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                >
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                >
                  {t('nav.whyUs')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                >
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('nav.contact')}</h3>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">
                <a href="mailto:admin@bridgeonsolutions.com" className="hover:text-cyan-400 transition-colors">
                  admin@bridgeonsolutions.com
                </a>
              </li>
              <li className="text-sm text-gray-400">
                <a href="tel:+1234567890" className="hover:text-cyan-400 transition-colors">
                  +1 (772) 667-4536
                </a>
              </li>
              <li className="text-sm text-gray-400">
                <a href="https://www.bridgeonsolutions.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  www.bridgeonsolutions.com
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.followUs')}</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/bridgeonsolutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-cyan-500 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-cyan-500 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-tiktok-line text-xl"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-cyan-500 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-cyan-500 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              {t('footer.copyright')}
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-cyan-400 transition-colors"
            >
              {t('footer.poweredBy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}